import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

import { FacetGroup, Place, PlaceType } from '@unreserved-frontend-v2/api/generated/graphql/types'
import {
  parseSlugVariables,
  formatAndSanatizeSluggedFilters,
} from '@unreserved-frontend-v2/modules/listings/utils/routing/parse-format-listings-slugged-values'
import { getRouteSplitQueryParams } from '@unreserved-frontend-v2/modules/listings/utils/routing/get-route-split-query-params'
import {
  DEFAULT_COUNTRY_SLUG,
  DEFAULT_LISTING_DIRECTORY,
} from '@unreserved-frontend-v2/modules/listings/utils/routing/constants'
import { LinksListItem } from '@unreserved-frontend-v2/ui/links-list/links-list'

export const useLinkedListValues = (
  metroArea?: FacetGroup,
  city?: FacetGroup,
  region?: FacetGroup,
  macroNeighbourhood?: FacetGroup,
  subNeighbourhood?: FacetGroup,
  neighbourhood?: FacetGroup,
  street?: FacetGroup,
  place?: Place | null,
  sectionPrefix = 'listings:listing-footer-links.popular'
) => {
  const { t } = useTranslation()
  const { query } = useRouter()
  const items = useMemo<LinksListItem[]>(() => {
    const rawItems = [region, metroArea, city, macroNeighbourhood, subNeighbourhood, neighbourhood, street]
    const slugVariables = parseSlugVariables(getRouteSplitQueryParams(query).routeParams['listing'] as string)

    return (rawItems as FacetGroup[])
      .filter((facetGroup) => facetGroup?.facets.length)
      .map<LinksListItem>(({ facets, name }) => ({
        title: t('listings:listing-footer-links.popular-types-in-location', {
          types: t(`listings:listing-footer-links.${name}`),
          location: place?.nameLong || t(`listings:listing-footer-links.${DEFAULT_COUNTRY_SLUG}`),
          popular: place && place.type !== PlaceType.Country ? t(sectionPrefix) : '',
        }),
        links: facets.map(({ name, count, ...facet }) => ({
          // TODO: Remove casting once backend fixes. Facet.id should never be nullable
          id: facet.id as string,
          name,
          count,
          url: `/${DEFAULT_LISTING_DIRECTORY}/${
            formatAndSanatizeSluggedFilters({ ...slugVariables, placeSlugs: [facet.id] }).sluggedFiltersString
          }`,
        })),
      }))
  }, [
    region,
    metroArea,
    city,
    macroNeighbourhood,
    subNeighbourhood,
    neighbourhood,
    street,
    query,
    t,
    place,
    sectionPrefix,
  ])

  return items
}
